import { Package, Phone } from "lucide-react";

export const Footer = () => (
  <footer className="py-12 bg-[#1F2937]" data-testid="footer">
    <div className="container-custom">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center">
            <Package className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-lg text-white" style={{ fontFamily: "Manrope" }}>CashForTestStripsJax</span>
        </div>
        <p className="text-white/60 text-sm">
          © {new Date().getFullYear()} cashforteststripsjacksonville.com
        </p>
        <a href="tel:+19049559646" className="flex items-center gap-2 text-white/60 text-sm hover:text-white transition-colors" data-testid="footer-phone">
          <Phone className="w-4 h-4" />
          <span>(904) 955-9646</span>
        </a>
      </div>
    </div>
  </footer>
);
